import { createSpacing } from "@mui/system";
 
export const spacing = createSpacing();
